<template>
  <div>
    <b-button :disabled="disabled" v-if="!saveMode" @click="editClick" size="sm" variant="primary" v-b-tooltip.hover :title="showToolTip ? 'Редактировать' : ''"><i class="fa fa-edit"></i></b-button>
    <b-button :disabled="disabled" v-if="saveMode" @click="saveClick" size="sm" variant="primary" v-b-tooltip.hover :title="showToolTip ? 'Сохранить' : ''"><i class="fa fa-save"></i></b-button>
  </div>
</template>

<script>

export default ({
  name: "button-edit-save",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data: () => {
    return {
      saveMode: false
    }
  },
  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    }
  },
  methods: {
    setEditState() {
      this.saveMode = false
    },

    setSaveState() {
      this.saveMode = true
    },

    editClick(event) {
      if (this.disabled) return

      this.saveMode = true;
      this.$emit('editClick', event)
    },

    saveClick(event) {
      if (this.disabled) return

      this.saveMode = false;
      this.$emit('saveClick', event)
    }
  }
})
</script>
